import { MongoId } from './mongoId';

export enum ChatChannelType {
  MEETING_CHANNEL = 'MEETING_CHANNEL',
  ORGANIZATION_CHANNEL = 'ORGANIZATION_CHANNEL',
  TASK_CHANNEL = 'TASK_CHANNEL',
  CONVERSATION_CHANNEL = 'CONVERSATION_CHANNEL',
}
export enum ChatMessageType {
  MESSAGE = 'MESSAGE',
  REMOVED_USER = 'REMOVED_USER',
  ADDED_USER = 'ADDED_USER',
  LEFT_CHAT = 'LEFT_CHAT',
  NEW_NAME = 'NEW_NAME',
  ADDED_ADMIN = 'ADDED_ADMIN',
  REMOVED_ADMIN = 'REMOVED_ADMIN',
  CHANGED_HISTORY = 'CHANGED_HISTORY',
  CREATED_CONVERSATION = 'CREATED_CONVERSATION',
  CALL_START = 'CALL_START',
  CALL_END = 'CALL_END',
}
export type IChatMessage = {
  _id?: MongoId;
  channelId: MongoId;
  type: ChatMessageType;
  organizationId: MongoId;
  fromUserId: MongoId;
  receivedAt: Date;
  editedAt: Date;
  message: string;
  read: MongoId;
  reactions: { emojiName: string; userIds: MongoId[] }[];
  editedMessageHistory: string[];
  replyToMessageId: MongoId;
  mentionedUserIds: MongoId[];
  isDeleted: boolean;
  deletedAt: Date | number;
  deletedByUser: MongoId;
  files: MongoId[];
};

export type IChannel = {
  _id: MongoId;
  id: string;
  chatChannelType: ChatChannelType;
  meetingId: MongoId;
  taskId: MongoId;
  organizationId: MongoId;
  usersToLastSeenMessage: any;
};
